import { createStyles, makeStyles } from '@material-ui/core';
import sicrediColor from 'assets/styles/default.scss';

export const useStyles = makeStyles(
  () =>
    createStyles({
      subtitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontSize: 20,
        fontWeight: 600,
        color: '#595959',
        marginTop: '0.5rem',
      },
      quorumTitle: {
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 'bold',
        marginBottom: '-0.5rem',
        color: sicrediColor.secondarySicrediDarker,
      },
      collapse: {
        '& svg': {
          color: '#3fa110',
          fontSize: '20px',
        },

        '&.active': {
          '& svg': {
            transform: 'rotate(-180deg)',
          },
        },
      },
      textWrapper: {
        color: sicrediColor.secondarySicrediDarker,

        '& > h1': {
          fontWeight: 'bold',
          marginBottom: '0.35rem',
        },

        '& p': {
          marginBottom: '0.35rem',
        },
      },
      textWrapperFilter: {
        color: sicrediColor.secondarySicrediDarker,
        margin: '1rem 0rem',

        '& > h1': {
          fontWeight: 'bold',
          marginBottom: '0.35rem',
        },
      },
      selectWrapper: {
        display: 'grid',
        gridTemplateColumns: '1fr, 1fr',
      },
      textGrid: {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '1rem',
        fontFamily: '"Nunito", sans-serif',
        fontWeight: 'bold',
        fontSize: '15px',
      },
      containerFilter: {
        position: 'relative',
        marginBottom: '3.5rem',

        '&:last-child': {
          marginBottom: '0rem',
        },

        '&:not(:last-child):after': {
          content: "' '",
          position: 'absolute',
          bottom: '-31px',
          width: '100%',
          height: '1px',
          margin: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
      },
      doughnutTextWrapper: {
        display: 'flex',
        alignItems: 'center',
        margin: '0.5rem 0rem',
      },
      agnNucWrapper: {
        display: 'flex',
        marginBottom: '0.5rem',

        '& > span:not(:last-child):after': {
          content: "' |'",
          width: '10px',
          height: '10px',
          margin: '0rem 0.5rem',
        },
      },
      associadoWrapper: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& > span:not(:last-child)': {
          marginRight: '0.5rem',
        },
      },
      progressBarWrapper: {
        width: '100%',
        background: sicrediColor.secondarySicrediLightest,
        padding: '24px',
        border: '1px solid #CDD3CD',
        borderRadius: '8px',
        margin: '1rem 0rem',
        cursor: 'pointer',

        '& .progress-bar-header': {
          margin: '1rem 0rem',
        },

        '&.event': {
          padding: '22px 24px 24px 24px',
        },
      },
      progressBarGroup: {
        width: '100%',
        marginBottom: '2rem',

        '& .progress-bar-header': {
          margin: '1rem 0rem',
        },
      },

      footerBtn: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginBottom: '1rem',
      },
    }),
  {
    name: 'AcompanharVotacaoPautaModal',
  }
);
